const $ = window.jQuery;
$(".stp-video").on("click", function () {
  stopVideo();
});
//Thumbnails
$(".cyc-carousel-navigator-image-container").on("click", function () {
  stopVideo();
});
$(".cyc-product-carousel-navigator").on("click", function () {
  stopVideo();
});
$(".cyc-navigation-arrow").on("click", function () {
  stopVideo();
});

function stopVideo() {
  if (document.getElementById("video_external")) {
    document
      .getElementById("video_external")
      .contentWindow.postMessage(
        '{"event":"command","func":"stopVideo","args":""}',
        "*"
      );
    document
      .getElementById("video_external_modal")
      .contentWindow.postMessage(
        '{"event":"command","func":"stopVideo","args":""}',
        "*"
      );
  }
}

function logBrowse(sku) {
  (function (d) {
    if (document.addEventListener)
      document.addEventListener("ltkAsyncListener", d);
    else {
      e = document.documentElement;
      e.ltkAsyncProperty = 0;
      e.attachEvent("onpropertychange", function (e) {
        if (e.propertyName == "ltkAsyncProperty") {
          d();
        }
      });
    }
  })(() => {
    console.log('ltk logBrowse fired', sku)
    _ltk.Activity.AddProductBrowse(sku);
    _ltk.Activity.Submit();
  });
}

var productDetails = window.ShopifyAnalytics.meta.product;
var selectedVariantId = window.ShopifyAnalytics.meta.selectedVariantId;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let fr = 0;
$(".selection-variant").on("change", function () {
  $(".size-error").slideUp();
  console.log("_opt7.js l31 .selection-variant called");
  let currentId = Number($(".selection-variant option:selected").val());
  var queryParams = new URLSearchParams(window.location.search);

  queryParams.set("variant", currentId);

  history.replaceState(null, null, "?" + queryParams.toString());
  internalUpdateProductDetail(currentId, "change");

  $("span[itemprop=sku]")
    .empty()
    .append($(".selection-variant option:selected").data("sku"));
  console.log("ltk sku", $(".selection-variant option:selected").data("sku"));
  logBrowse($(".selection-variant option:selected").data("sku"));
});

if (urlParams.has("variant")) {
  let currentId = Number(urlParams.get("variant"));
  $(".selection-variant option[data-info='Please select']").remove();

  $(".selection-variant option[data-info=" + currentId + "]").attr(
    "selected",
    "selected"
  );
  setTimeout(function () {
    Shopify.updateProductDetail(currentId, "new");

    try {
      const variantImage = document.querySelector(
        `.cyc-product-carousel > div [data-variant-id="${currentId}"]`
      );
      if (variantImage) {
        console.log(
          "scrolling to index",
          `.cyc-product-carousel > [data-variant-id="${currentId}"]`
        );
        $(".cyc-product-carousel").slick(
          "slickGoTo",
          parseInt(variantImage.dataset.slickIndex)
        );
      }
    } catch (e) {
      console.log("exception thrown while scrolling", e);
    }
  }, 500);
} else {
  let currentId = $(".product-first").val();
  $(".selection-variant option:selected").val(currentId);
  setTimeout(function () {
    Shopify.updateProductDetail(currentId, "new", true);
  }, 500);
}

$(".form-detail-product").on("submit", function () {
  const sizeVal = $(".selection-variant option:selected").text();
  //console.log("-> sizeVal", sizeVal);
  if (sizeVal === "Please select") {
    $(".size-error").slideDown();
    return false;
  }
});

$(document).on("click", ".action_button.add_to_cart[type=button]", function () {
  // alert("Please select an option");
  $(".size-error").slideDown();
});

// $(".selection-variant").on("change", function () {
//     $(".size-error").slideUp();
// });
if (typeof Shopify === "undefined") {
  Shopify = {};
}
Shopify.formatMoney = function (cents, format) {
  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || this.money_format;

  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
const internalUpdateProductDetail = (Shopify.updateProductDetail = function (
  currentId,
  statusPage,
  firstEnter = false
) {
  document.querySelectorAll('form.product_form').forEach(function (form) {
    const control = form.querySelector('[name="id"]');
    const selected = control && control.tagName === 'SELECT'
      ? Array.from(control.options).find(option => option.value === String(currentId))
      : control;
    form.dataset.wcQbpOnly = selected && selected.dataset.wcQbpOnly === 'true' ? 'true' : 'false';
  });
  let products = {};
  $.getJSON(
    "/products/" + $(".data-hand").val() + ".js?action=optimum7",
    function (response) {
      if (!firstEnter) {
        try {
          const variantImage = document.querySelector(
            `.cyc-product-carousel > div [data-variant-id="${currentId}"]`
          );
          if (variantImage) {
            console.log(
              "scrolling to index",
              `.cyc-product-carousel > [data-variant-id="${currentId}"]`
            );
            $(".cyc-product-carousel").slick(
              "slickGoTo",
              parseInt(variantImage.dataset.slickIndex)
            );
          }
        } catch (e) {
          console.log("exception thrown while scrolling", e);
        }
      }

      //console.log('%c /products/' + $(".data-hand").val() + '.js?action=optimum7 ', 'background: #222; color: #ffffff');
      //console.log('%c Current ID:' + currentId, 'background: red; color: #ffffff');
      if (response) {
        //products = product;
        products = response;
        //console.log(products);

        const current_product = products.variants.find(
          (x) => x.id === Number(currentId)
        );
        if (!current_product) return;

        $("span[itemprop=sku]").empty().append(current_product.sku);
        $("span[itemprop=mpn]").empty().append(current_product.barcode);
        console.log("sku is updated");

        const isSpecial = current_product.inventory_policy === "continue";
        const isOutOfStock = current_product.inventory_quantity <= 0;
        console.log("isSpecial", isSpecial);
        console.log("isOutOfStock", isOutOfStock);

        if (statusPage !== "new") {
          var queryParams = new URLSearchParams(window.location.search);
          queryParams.set("variant", currentId);
          history.replaceState(null, null, "?" + queryParams.toString());
        }

        console.log("ltk sku", current_product.sku);
        $("span[itemprop=sku]").empty().append(current_product.sku);

        logBrowse(current_product.sku);

        const anyVariantInStock = products.variants.filter(v => v.inventory_quantity > 0).length > 0
        if (anyVariantInStock === true && firstEnter) {
          console.log('called')
                  $(".quantity_alert_box").removeClass("d-begin");
                $(".quantity_alert_box span")
                        .empty()
                        .append("Fast & Free Shipping!");
        }

        const hasOneVariant = products.variants.length === 1
        $.each(products.variants, function (key, value) {
          // console.log("-> value", value);
          let id = parseInt(value.id);
          let name = value.name;
          let price = value.price;
          if (parseInt(currentId) === id) {
            console.log("-> currentId", currentId);
            let currentListPrice = value.compare_at_price / 100;
            console.log({ cap: value.compare_at_price, price });
            if (currentListPrice === 0 || currentListPrice === price / 100) {
              $(".compare-at-price").hide();
              $(".save-price").hide();
              $(".sale-price .price_label").hide();
              $(".current_price .money")
                .empty()
                .append(Shopify.formatMoney(price));
              $(".was_price").empty().append(Shopify.formatMoney(price));
              $(".sale_price .money")
                .empty()
                .append(Shopify.formatMoney(price));
            } else {
              $(".compare-at-price").show();
              $(".save-price").show();
              $(".sale_price .price_label").show();
              $(".sale-price .price_label").show();
              $(".was_price")
                .empty()
                .append(Shopify.formatMoney(value.compare_at_price));
              $(".sale_price .money")
                .empty()
                .append(Shopify.formatMoney(price));
              $(".current_price .money")
                .empty()
                .append(Shopify.formatMoney(price));

              let finalSave = Number(currentListPrice - price / 100).toFixed(2);

              let formattedPrice = Shopify.formatMoney(
                finalSave,
                "{{ amount }}"
              );

              let finalSavePercentage = Math.round(
                (
                  ((currentListPrice - price / 100) / currentListPrice) *
                  100
                ).toFixed(2)
              );
              console.log("Comma Product Price: " + formattedPrice);
              console.log("-> price", price / 100);
              console.log("-> finalSave", finalSave);
              console.log(
                "-> fark",
                ((currentListPrice - price / 100) / currentListPrice) * 100
              );
              console.log("-> finalSavePercentage", finalSavePercentage);
              if (finalSavePercentage > 0.05) {
                $(".you_save")
                  .empty()
                  .append(
                    '<span class="money" data-currency-usd="' +
                      formattedPrice +
                      '">' +
                      formattedPrice +
                      "</span>"
                  )
                  .append(" (" + finalSavePercentage + "%)");
              } else {
                $(".you_save")
                  .empty()
                  .append(
                    '<span class="money" data-currency-usd="' +
                      formattedPrice +
                      '">' +
                      formattedPrice +
                      "</span>"
                  );
              }
            }

            let options = "";
            for (
              i = 1;
              i <=
              (value.inventory_quantity > 100 ? 100 : value.inventory_quantity);
              i++
            ) {
              options += '<option value="' + i + '">' + i + "</option>";
            }
            $(".quantity").empty().append(options);
            if (value.inventory_quantity === 0) {
              //console.log('%c ' + value.name + ' Out Of Stock ', 'background: #b52735; color: #ffffff');
              // Out of stock!!!
              $(".quantity-section").hide();
              $("#special-order-button").hide();
              $(".action_button.add_to_cart")
                .attr("type", "button")
                .prop("disabled", true)
                .val("Out of stock")
                .hide();
              $(".quantity_alert_box").hide();
              $(".notify_form").slideDown();
              $(".out-message").slideDown();
              if (statusPage === "new") {
                setTimeout(function () {
                  $(".quantity_alert_box").removeClass("d-begin");
                }, 1500);
              } else {
                $(".quantity_alert_box").removeClass("d-begin");
              }
              //console.log('%c firstEnter:' + firstEnter, 'background: blue; color: #ffffff');
              if (key === 0 && firstEnter) {
                $(".quantity-section").show();
                $("#special-order-button").hide();
                $(".action_button.add_to_cart")
                  .attr("type", "button")
                  .prop("disabled", false)
                  .val("Add to cart")
                  .show();
                $(".out-message").hide();
                $(".notify_form").hide();
                // setTimeout(function () {
                //   $(".quantity_alert_box").removeClass("d-begin").show();
                //   $(".quantity_alert_box span")
                //     .empty()
                //     .append("Fast & Free Shipping!");
                // }, 500);
                for (i = 1; i <= 30; i++) {
                  options += '<option value="' + i + '">' + i + "</option>";
                }
                $(".quantity").empty().append(options);
              }
            } else {
              $(".right-information").show();
              $(".out-message").hide();
              $(".quantity-section").show();
              $("#special-order-button").hide();
              $(".action_button.add_to_cart")
                .attr("type", "submit")
                .prop("disabled", false)
                .val("Add To Cart")
                .show();
              $(".quantity_alert_box").show();
              $(".notify_form").hide();
              const currentPrice = value.price / 100;
              //console.log("-> currentPrice", currentPrice);
              if (statusPage !== "new") {
                //console.log('%c Status Change ', 'background: #ccc; color: #000');
                $(".quantity_alert_box").removeClass("d-begin");
                if (value.inventory_quantity >= 4) {
                  //console.log('%c ' + value.name + ' More than 4 ', 'background: #242424; color: #ffffff');
                  if (currentPrice >= 45) {
                    $(".quantity_alert_box span")
                      .empty()
                      .append("Fast & Free Shipping!");
                  } else {
                    $(".quantity_alert_box span")
                      .empty()
                      .append("Fast & Free Shipping!");
                  }
                } else if (
                  value.inventory_quantity <= 3 &&
                  value.inventory_quantity > 0
                ) {
                  //console.log('%c ' + value.name + ' Between 1 - 4 ', 'background: #242424; color: #ffffff');
                  if (currentPrice >= 45) {
                    $(".quantity_alert_box span")
                      .empty()
                      .html(
                        "FAST & FREE SHIPPING! ONLY " +
                          value.inventory_quantity +
                          " LEFT IN STOCK"
                      );
                  } else {
                    $(".quantity_alert_box span")
                      .empty()
                      .html(
                        "FAST & FREE SHIPPING! ONLY " +
                          value.inventory_quantity +
                          " LEFT IN STOCK"
                      );
                  }
                }
              }
            }
            //SKU - MPN
          } else {
            // console.log('%c Current ID is not equal ', 'background: #ccc; color: #000');
          }
        });

        if (isSpecial && isOutOfStock && (!firstEnter || hasOneVariant)) {
          console.log("Special Ordera");
          $(".right-information").show();
          $(".out-message").hide();
          $(".quantity-section").show();
          $(".action_button.add_to_cart")
            .val(`*Special Order*`)
            .attr("type", "submit")
            .prop("disabled", false)
            .show();
          $(".quantity_alert_box").show();
          $(".notify_form").hide();
          $(".quantity_alert_box").hide();
          $(".right-information").hide();
          let options = "";
          for (i = 1; i <= 30; i++) {
            options += '<option value="' + i + '">' + i + "</option>";
          }
          $(".quantity").empty().append(options);
          document.querySelector(
            "#proton-special-order-input"
          ).disabled = false;
        } else {
          document.querySelector("#proton-special-order-input").disabled = true;
        }
      }
    }
  );
});
function changeUrlParam(param, value) {
  var currentURL = window.location.href;
  var urlObject = currentURL.split("?");
  var newQueryString = "?";

  value = encodeURIComponent(value);

  if (urlObject.length > 1) {
    var queries = urlObject[1].split("&");

    var updatedExistingParam = false;
    for (i = 0; i < queries.length; i++) {
      var queryItem = queries[i].split("=");

      if (queryItem.length > 1) {
        if (queryItem[0] == param) {
          newQueryString += queryItem[0] + "=" + value + "&";
          updatedExistingParam = true;
        } else {
          newQueryString += queryItem[0] + "=" + queryItem[1] + "&";
        }
      }
    }
    if (!updatedExistingParam) {
      newQueryString += param + "=" + value + "&";
    }
  } else {
    newQueryString += param + "=" + value + "&";
  }
  window.history.replaceState(
    "",
    "",
    urlObject[0] + newQueryString.slice(0, -1)
  );
}
